import * as React from 'react';

import { TextLink } from '@lightspeed/flame/Text';

import { createReactRenderer } from '../helpers/react-renderer';

import { ReportModal } from './ReportModal';
import { REPORT_TYPE } from './types';

const MakeTaxDigitalUK: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [reportType, setReportType] = React.useState<REPORT_TYPE | undefined>(undefined);

  const openModal = (type: REPORT_TYPE) => {
    setIsModalOpen(true);
    setReportType(type);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <React.Fragment>
      {/* @ts-expect-error ts-migrate(2322) FIXME: Type 'REPORT_TYPE | undefined' is not assignable t... Remove this comment to see the full error message */}
      <ReportModal open={isModalOpen} type={reportType} handleClose={closeModal} />
      <ul>
        <li>
          <TextLink
            onClick={() => openModal(REPORT_TYPE.RETAIL)}
            id="UKDigitalRetailVatReport"
            data-type="report"
          >
            <span data-automation="buttonTitle">UK Digital Retail VAT Report</span>
          </TextLink>
          <span> - Generate MTDfV UK Digital Retail VAT report</span>
        </li>
        <li>
          <TextLink
            onClick={() => openModal(REPORT_TYPE.NORMAL)}
            id="UKDigitalNormalVatReport"
            data-type="report"
          >
            <span data-automation="buttonTitle">UK Digital Normal VAT Report</span>
          </TextLink>
          <span> - Generate MTDfV UK Digital Normal VAT report</span>
        </li>
      </ul>
    </React.Fragment>
  );
};

const RenderedComponent = createReactRenderer({
  component: MakeTaxDigitalUK,
  selector: '[data-react-root="MakeTaxDigitalUK"]',
});

history.onChangeState(
  { form_name: 'ui_tab', tab: 'reports' },
  () => {
    RenderedComponent.mount();
  },
  () => {
    RenderedComponent.unmount();
  }
);

export default MakeTaxDigitalUK;
